import {Component, Input, OnInit} from '@angular/core';
import {StatnaSkuska} from '../model/statnaSkuska';
import {AppService} from '../app.service';
import {Studium} from '../model/studium';

@Component({
    selector: 'app-statne-skusky',
    templateUrl: './statne-skusky.component.html',
    styleUrls: ['./statne-skusky.component.css'],
    standalone: false
})
export class StatneSkuskyComponent implements OnInit {

  @Input()
  data: StatnaSkuska[];

  @Input()
  studium: Studium;

  show = true;

  constructor(private appService: AppService) { }

  ngOnInit() {
  }

  headerClick() {
    this.show = !this.show;
  }

  openKontrolaPrerekvizit() {
    this.appService.openPortalAppWindow(
      'ais.gui.vs.es.VSES131_StudijneKontrolaPrerekvizitStatnicDlg',
      this.studium.id
    );
  }

  openPrihlasenieNaTermin() {
    this.appService.openPortalAppWindow(
      'ais.gui.vs.es.VSES342_PrihlasenieNaStatnuSkuskuStudent',
      this.studium.id
    );
  }
}
